module.exports = __webpack_public_path__ + "static/media/Sachin Ji-Model_page-0001.9a709c2d.jpg";